export default [
  {
    name: 'Pix',
    state: false,
    method: "pix",
    slug: "pix",
    show: true
  },
  {
    name: 'Boleto',
    state: false,
    method: "bank_slip" ,
    slug: "boleto" ,
    show: false
  },
  {
    name: 'Cartão de crédito',
    state: false,
    method: "credit_card",
    slug: "cartao",
    show: true
  }
]
